import script from "./PostView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostView.vue?vue&type=script&setup=true&lang=ts"

import "./PostView.vue?vue&type=style&index=0&id=5d9877e4&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d9877e4"]])

export default __exports__